import React, { useEffect } from "react";
import Header from './header/Header';
import HomePage from "./homepage/HomePage";
import Footer from "./footer/Footer";
import { Route, Routes, useLocation } from "react-router-dom";
import Contact from "./contact/Contact";
import About from "./about/About";
import { AnimatePresence } from "framer-motion";

const App = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [location]);

    return (
        <>
            <Header />
            <AnimatePresence mode="wait">
                <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/about-us" element={<About />} />
                </Routes>
            </AnimatePresence>
            <Footer />
        </>
    );
};

export default App;